import { Component, Vue } from 'vue-property-decorator';
import { RequestStatusId, LeaveTypeId } from '@/types/request';
import { UserId } from '@/types/user';


@Component({})
export default class RequestsService extends Vue {
  public requestStatusColors: { [id in RequestStatusId]: string } = {
    1: 'blue',
    2: 'orange',
    3: 'green',
    4: 'grey',
    5: 'red',
  };

  get leaveTypeOptions() {
    return this.leaveTypes.map((leaveType: any) => ({
      text: leaveType.name,
      value: leaveType.id,
    }));
  }

  get requests() {
    return this.$store.getters['requests/list'];
  }

  get requestStatuses() {
    return this.$store.getters['requestStatuses/list'];
  }

  get users() {
    return this.$store.getters['users/list'];
  }

  get leaveTypes() {
    return this.$store.getters['leaveTypes/list'];
  }

  public getUser(userId: UserId): string {
    const userObject = this.users.find((user: any) => user.id === userId);
    if (!userObject) { return ''; }
    return userObject.name;
  }

  public getType(typeId: LeaveTypeId): string {
    const typeObject = this.leaveTypes.find((type: any) => type.id === typeId);
    if (!typeObject) { return ''; }
    return typeObject.name;
  }

  public getStatus(statusId: RequestStatusId | null): string {
    if (!statusId) { return ''; }
    const statusObject = this.requestStatuses.find((status: any) => status.id === statusId);
    if (!statusObject) { return ''; }
    return statusObject.name;
  }

}
